import { render, staticRenderFns } from "./subdomain-interstitial-loader.vue?vue&type=template&id=5a3c1fd8"
import script from "./subdomain-interstitial-loader.vue?vue&type=script&lang=js"
export * from "./subdomain-interstitial-loader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5a3c1fd8')) {
      api.createRecord('5a3c1fd8', component.options)
    } else {
      api.reload('5a3c1fd8', component.options)
    }
    module.hot.accept("./subdomain-interstitial-loader.vue?vue&type=template&id=5a3c1fd8", function () {
      api.rerender('5a3c1fd8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/client-portal/js/modules/subdomain-interstitial/components/subdomain-interstitial-loader.vue"
export default component.exports